import React from 'react';
import bemHelper from 'react-bem-helper';
import objectFitImages from 'object-fit-images';
import { connect } from 'react-redux';

import '../../../config';
import { requestStorefront, previewStorefront, storefrontData } from '../actions';
import Storefront from './Storefront';

export class App extends React.Component {

  static needs = [requestStorefront];
  static data = storefrontData;

  componentDidMount() { // eslint-disable-line
    if (window && typeof Image !== 'undefined') {
      objectFitImages();
    }

    if (window.storefrontPreview && window.storefrontPreview.session.preview) {
      this.props.previewStorefront(window.storefrontPreview);
    }
  }

  render() {
    const bem = bemHelper({ prefix: 'toga-', name: 'storefront' });
    const { storefront = {} } = this.props;
    return (
      <div {...bem()}>

        {storefront.data &&
        <script
          type="application/ld+json"
                dangerouslySetInnerHTML={
                  { __html: JSON.stringify(storefront.data.richSnippet) }}>
        </script>}

        {storefront.data && <Storefront {...storefront} /> }
      </div>
    );
  }

}

function mapStateToProps({ storefront }) {
  return {
    storefront,
  };
}

export default connect(
  mapStateToProps,
  { requestStorefront, previewStorefront }
)(App);



// WEBPACK FOOTER //
// ./src/components/storefront/containers/App.js